import React from 'react';

const CoachingGetStarted = () => (
  <section id="one" className="main style1">
    <div className="grid-wrapper">
      <div className="col-12">
        <header className="major">
          <h2>Free Strategy Session</h2>
          <p>Discover if coaching is for you.</p>
        </header>
        <p>
          This free strategy session with Caitlin Baird will help you explore where you are, where you want to go and what it may take to get you there. You’ll also have the opportunity to ask questions about the ‘what and why’ of coaching. This is intended to be a pressure-free to experience coaching with Caitlin Baird. The hope is that you discover immediate, meaningful value, regardless if you continue the coaching relationship.
        </p>
        <p>
          <strong>What Now:</strong> Click the “Book Now” button below and indicate your preferred date(s) and time(s) for you Strategy Session. There will be no payment required at this time. This can take place via telephone or video conference.
        </p>
      </div>
      <div className="col-12">
        <header className="major">
          <h2>Group Coaching Consultation</h2>
        </header>
        <p>
          Group coaching combines the principles of coaching with the small group context. It is a personal, specific space focused on discovering what’s happening now, what’s working, what isn’t and what to do about it. Sometimes, people find the expense of one-on-one coaching an obstacle.  Group Coaching is a great way to enroll others into session with Caitlin Baird, increasing the learning but reducing the individual cost per session.
        </p>
        <p>
          For teams, it can be challenging to move forward when everyone is just not on the same page. For small groups or friends, you may find you want to go deeper with one another but seem unable to have the depth you long for. You can book group coaching for people you already know, or join a waitlist for the next round of group coaching.
        </p>
        <p>
          What Now: Get together with those you want to enroll. Determine the optimal dates/times that work for your group. Click the button below to book your half-hour strategy session around how Caitlin can best support your group vision. Alternatively, if you want to join the wait-list for group coaching, also select the “Book now” button and mention that in the comments.
        </p>
      </div>
    </div>
  </section>
);

export default CoachingGetStarted;